import * as React from 'react';

const MOBILE_BREAKPOINT = 768;

function readIsMobileViewport(): boolean {
  if (typeof window === 'undefined') return false;
  return window.innerWidth < MOBILE_BREAKPOINT;
}

/**
 * Viewport-only mobile breakpoint (`< 768px`).
 * Shell chrome (sidebar vs native tab bar) must use Capacitor/native checks
 * in the app — never OR native into this hook.
 */
export function useIsMobile() {
  const [isMobile, setIsMobile] = React.useState(readIsMobileViewport);

  React.useEffect(() => {
    const mql = window.matchMedia(`(max-width: ${MOBILE_BREAKPOINT - 1}px)`);
    const onChange = () => {
      setIsMobile(readIsMobileViewport());
    };
    mql.addEventListener('change', onChange);
    return () => mql.removeEventListener('change', onChange);
  }, []);

  return isMobile;
}
